module.exports = __webpack_public_path__ + "nitrum.svg?829f3270cb45c3492eee02b39fb98506";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/nitrum.svg
// module id = 144
// module chunks = 0